import React, { createContext, useContext } from 'react';
import { useLoading } from '@/hooks';

interface LoadingContextType {
  globalLoading: ReturnType<typeof useLoading>;
}

const LoadingContext = createContext<LoadingContextType | null>(null);

export const LoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const globalLoading = useLoading();

  return (
    <LoadingContext.Provider
      value={{
        globalLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoadingContext = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoadingContext must be used within an LoadingProvider');
  }
  return context;
};
